export default __webpack_public_path__ + "static/media/Anuphan-Regular.e0ae7ca2.woff";